import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AnimationOptions } from 'ngx-lottie';
import { AppResource } from 'src/app/app.resource';
import { Resource } from 'src/app/resources/resource';

@Component({
  selector: 'app-error-popup',
  templateUrl: './error-popup.component.html'
})
export class ErrorPopupComponent implements OnInit {
  @Input() show: boolean = false;

  @Input() title: string = '';

  @Input() loading: boolean = false;

  @Input() text: string = '';

  @Input() closeable: boolean = true;

  @Output() cancel = new EventEmitter<boolean>();

  options!: AnimationOptions;

  public resource!: Resource;

  constructor(private resources: AppResource) {
    this.resource = this.resources['resource'];
  }

  ngOnInit(): void {
    this.options = {
      path: this.resource?.lottie?.loading ?? ''
    };
  }

  onCancel() {
    this.cancel.emit();
  }
}
